export default "<pplus-input-password [placeholder]=\"'Your password'\"></pplus-input-password>"